import React from 'react';
import * as api from '../../../../api/doc'
import PageList from '../../../../components/PageListAPI'
import { getLabel } from '../function'
import { useCan } from '../../../../hooks/useCan';
import { SLUGS } from '../../../../enum/permissions.enum';

export default function ToolWrite({ history, match, location }) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='useToolList'
        title='Документы приемки оборудования'
        columns={[
          { id: 'id', name: '№' },
          { id: 'date', name: 'Дата приемки', type: 'date' },
          { id: 'inventory', name: 'Оборудование', },
          { id: 'user', name: 'Принял', },
          { id: 'worker', name: 'Сдал', },
          { id: 'position', name: 'Должность', },
          { id: 'type', name: 'Тип списания', },
        ]}
        createItem={can(SLUGS.PROJECT.TOOL_UW.WRITE_MANAGE)}
        deleteItem={can(SLUGS.PROJECT.TOOL_UW.WRITE_MANAGE)}
        idName='id'
        history={history}
        match={match}
        location={location}
        loadAPI={{
          param: {
            id: match.params.idProject
          },
          request: api.getToolWrite,
          transform: (res => {
            return {
              count: res.count,
              get: res.get.map(obj => {
                return {
                  id: obj.id,
                  user: obj.gSurname + ' ' + obj.gName,
                  worker: obj.surname + ' ' + obj.name[0] + '.' + obj.patronymic[0] + '.',
                  position: obj.position,
                  date: obj.date,
                  type: getLabel(obj.type),
                  inventory: obj.inventoryNumber.toString().padStart(5, '0') + ' ' + obj.inventoryName,
                }
              })
            }
          }),
        }}
        deleteAPI={api.deleteToolWriteById(match.params.idProject)}
        headerInit={{
          sortBy: 'date',
          sortDirection: 'desc',
        }}
      />
    </div>
  )
}


